import request from '@/utils/request'
let baseURL = '/anttalk-member';

//平台及所有店铺会员奖金汇总数据
export function getAllMemberEarnData(data) {
  return request({
    url: `/api/settle/v1/getAllMemberEarnData`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */


// 会员管理-平台会员-奖金数据
export function getPlatformMemberEarnData(data) {
  return request({
    url: `/api/platform/user/v1/getPlatformMemberEarnData`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */

// 会员管理-平台会员-获取用户当前的会员等级
export function memberPlatformGrade(data) {
  return request({
    // 废弃--------------
    url: `/api/platform/user/v1/memberPlatformGrade`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */
export function memberPlatformGradeV2(params) {
  return request({
    url: `/api/platform/user/v2/memberPlatformGrade`,
    method: 'get',
    baseURL,
    params
  })
}

// 会员管理-平台会员-当前用户的下1级、下2级用户，分别按会员等级进行统计
export function countPlatformMember(data) {
  return request({
    url: `/api/platform/user/v1/countPlatformMember`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */


// 会员管理-平台会员-当前用户的下1级用户列表
export function getPlatformChildMemberLevelStatOfL1(data) {
  return request({
    url: `/api/platform/user/v1/getPlatformChildMemberLevelStatOfL1`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */


// 会员管理-平台会员-一级用户下一级统计
export function getPlatformMemberChildLevel1Stat(data) {
  return request({
    url: `/api/platform/user/v1/getPlatformMemberChildLevel1Stat`,
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */


// 会员结算
// export function listEarnDetails(data) {
//   return request({
//     url: '/api/settle/v1/listEarnDetails',
//     method: 'post',
//     baseURL,
//     data
//   })
// }
/*
{
earnType (string, optional): 收益类型大类：PLATFORM_MEMBER-平台会员收益；SHOP_MEMBER-店铺会员收益 = ['PLATFORM_FEE', 'PLATFORM_MEMBER', 'SHOP_MEMBER'],
page (integer, optional),
shopId (integer, optional): 店铺会员收益时需传店铺ID ,
size (integer, optional),
userId (string, optional): 用户OPENID
}
* */



//----------------------------            店铺会员接口：               ---------------------------------//

// 会员管理-店铺会员-会员店铺列表
export function memberShopList(data) {
  return request({
    url: '/api/mall/user/v1/memberShopList',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
page (integer, optional),
size (integer, optional)
}
* */


// 会员管理-店铺会员-店铺会员用户首页信息
export function getShopMemberUserHomeInfo(data) {
  return request({
    url: '/api/mall/user/v1/getShopMemberUserHomeInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
shopId (integer): 店铺ID ,
page (integer, optional),
size (integer, optional)
}
* */


// 会员管理-店铺会员-用户直接推荐店铺用户列表
export function userDirectIntiveList(data) {
  return request({
    url: '/api/mall/user/v1/userDirectIntiveList',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
shopId (integer): 店铺ID ,
page (integer, optional),
size (integer, optional)
}
* */


// 会员管理-店铺会员-当前用户的某下1级用户，其下级分会员等级进行统计
export function getChildMemberLevelStatOfL1(data) {
  return request({
    url: '/api/mall/user/v1/getChildMemberLevelStatOfL1',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
inviteUserIdOnLevel1 (string): 会员用户ID ,
shopId (integer): 店铺ID
}
* */


// 会员管理-店铺会员-当前用户的下1级、下2级用户，分别按会员等级进行统计
export function getChildMemberLevelStatOfL1L2(data) {
  return request({
    url: '/api/mall/user/v1/getChildMemberLevelStatOfL1L2',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
inviteUserId (string, optional): 会员用户ID(不传时为店铺邀请) ,
shopId (integer): 店铺ID
}
* */



// 店铺主页-查询是否拥有 开通店铺会员 功能
export function giftInfo(data) {
  return request({
    url: '/api/mall/shop/v1/check/giftinfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
openid (string): openid ,
shopId (integer): shopId
}
* */
